//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import DIC from '@/index/dictionary'
import util from '@/index/libs/util.js'
import axios from 'axios'
import Vue from 'vue'
let baseURL = axios.defaults.baseURL
// console.log('baseURL', baseURL)
export default {
  props: {
    autoUpload: {
      default: true
    },
    data: {
      default: () => ({})
    },
    limit: {
      default: 1
    },
    value: {
      type: [String, Array],
      default: ''
    },
    width: {
      default: ''
    },
    height: {
      default: ''
    },
    action: {
      default: `/hi/operate/article/uploadFile`
    },
    listType: {
      default: 'picture-card'
    },
    showFileList: {
      default: true
    },
    onSuccess: {
      default: undefined
    }
  },
  watch: {
    value: {
      handler (val) {
        // if (val) {
          // console.log('val', val)
        // }
        this.fileList = this.getFileList(val)
      }
    }
  },
  data: function () {
    return {
      currentData: _.extend({
        token: util.cookies.get('token')
      }, this.data),
      fileList: this.getFileList(this.value),
      dialogImageUrl: '',
      dialogVisible: false,
      name: 'file',
      imageUrl: '',
      currentAction: `${baseURL}${this.action}`
    }
  },
  mounted () {
  },
  methods: {
    getFileList (value) {
      let r = []
      console.log('value', value)
      if (value) {
        if (_.isString(value)) {
          let url = Vue.filter('oss')(value)
          let name = ''
          if (url.indexOf('/video/') > -1) {
            url = Vue.filter('videoSnapshot')(value)
            name = value
          }
          r.push({
            name: name,
            url: url
          })
        } else if (_.isArray(value)) {
          _.each(value, (t, i, l) => {
            r.push({
              name: '',
              url: Vue.filter('oss')(t)
            })
          })
        }
      }
      return r
    },
    handleRemove (file, fileList) {
      // console.log('file', file)
      // console.log('fileList', fileList)
      if (this.limit === 1) {
        this.imageUrl = ''
        this.$emit('input', '')
      } else {
        let url = file.url.substr(DIC.OSS.length)
        // console.log('url', url)
        let index = _.indexOf(this.value, url)
        // console.log('url', file.url)
        // console.log('value', this.value)
        // console.log('index', index)
        this.value.splice(index, 1)
        this.$emit('input', this.value)
      }
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleSuccess (response, file, fileList) {
      // console.log('response', response)
      // console.log('file', file)
      // console.log('fileList', fileList)
      if (this.onSuccess) {
        this.onSuccess(response, file, fileList)
      } else {
        if (this.limit === 1) {
          this.imageUrl = response.data
          this.$emit('input', this.imageUrl)
        } else {
          this.value.push(response.data)
          this.$emit('input', this.value)
        }
      }
    },
    handleExceed (file, fileList) {
      this.$notify.warning({
        title: '系统提示',
        message: '请先删除文件'
      })
    },
    handleChange (file, fileList) {
      // console.log('handleChange', )
      // console.log('file', file)
      // console.log('file.name', file.name)
      // console.log('file.url', file.url)
      // console.log('fileList', fileList)
      if (this.listType === 'text') {
        this.$emit('input', file.name)
      }
    }
  }
}
